module.exports = __webpack_public_path__ + "images/help_v2/avatars/ruochen-b250fa1630dc72380442785fe5b43ba4.png";